import { FAMILY_OF_FOUR_SIZE } from '@/lib/refrigerator-answer-facts'

/**
 * The /tools FAQ (FRIDGE-1440): one list for the questions the page shows
 * (app/tools/tools-client.tsx) and its FAQPage node
 * (components/seo/tools-index-schemas.tsx), the way lib/local/local-index-faqs.ts
 * serves /local. Until 10/08/2026 the node carried three answers the page never
 * showed (FRIDGE-380: structured data describes what the page shows).
 */
/**
 * FRIDGE-257: the running-cost answer is arithmetic, not an asserted price. The
 * kWh span was MEASURED from this catalog (energy-rated full-size refrigerators,
 * 10th–90th percentile of 427 rated rows, 08/31/2026); the dollar range is that
 * span times the example rate, computed here.
 */
const RATED_KWH_P10 = 355
const RATED_KWH_P90 = 715
const EXAMPLE_RATE_CENTS = 15
const dollarsPerYear = (kwh: number) => Math.round((kwh * EXAMPLE_RATE_CENTS) / 100)

export interface ToolsIndexFaq {
  question: string
  answer: string
}

export const TOOLS_INDEX_FAQS: readonly ToolsIndexFaq[] = [
  {
    question: 'What size refrigerator do I need for a family of 4?',
    // FRIDGE-1435: the size calculator's own answer, the one the homepage and
    // /llms.txt give (lib/refrigerator-answer-facts.ts).
    answer: `${FAMILY_OF_FOUR_SIZE.answer} Use the Refrigerator Size Calculator at Fridge.com for personalized recommendations.`,
  },
  {
    question: 'How much does a refrigerator cost to run per year?',
    // FRIDGE-257: was an invented "$50-100 per year" attributed to the
    // calculator; now the arithmetic it is, computed from the constants above.
    answer: `Yearly cost is the model's rated kWh/year times your electricity rate. Energy-rated full-size refrigerators in the Fridge.com catalog span roughly ${RATED_KWH_P10}-${RATED_KWH_P90} kWh per year (10th-90th percentile of rated models), so at a ${EXAMPLE_RATE_CENTS}¢/kWh rate that is about $${dollarsPerYear(RATED_KWH_P10)}-${dollarsPerYear(RATED_KWH_P90)} a year — your rate decides your number. Compute it exactly with the free Energy Cost Calculator.`,
  },
  {
    question: 'Are these refrigerator calculators free?',
    answer:
      'Yes, all tools at Fridge.com are 100% free with no registration required. Fridge.com offers ninety free interactive tools for refrigerator sizing, energy costs, and kitchen planning.',
  },
]
